import React from "react"
import { useState, useEffect } from "react"
import apiFetcher from "../../utils/apiFetcher"
import { MoneyExchangeOffer } from "../../utils/exchangeOffer"
import { MoneyExchangeFirstStep } from "./MoneyExchangeComponents/MoneyExchangeFirstStep"
const ExchangeOption = ({amount,price,points,setPoints, setPayout,setUrl}) => {
    const [error,setError] = useState(``);
    const handlePayOut = async () => {
        if(points < amount) {
            setError(`Masz za mało punktów.`);
            return;
        };
        const {success,url} = await apiFetcher.createPayOutLink(amount);
        setPoints(points - price);
        if(!success || !url) {
            setError(`Masz za mało punktów.`);
            return;
        };
        setUrl(url);
        setPayout(success);





    }

    return (
        <div className="offer-panel">
            <img width="512" height="512" loading="lazy" src="photos/saving-icon.webp" alt="Wypłata pięniędzy"></img>
            <p><b>Wypłata pieniędzy</b></p>
            <p>Koszt: {price} punktów </p>
            <p>Do odebrania: <b>{amount}zł</b></p>
            <button onClick={handlePayOut}><h3>Wypłać</h3></button>
            <p><b>{error}</b></p>
        </div>
    )

    


}


const MoneyExchange = ({setPoints, points}) => {
    const [isActivePayout, setIsActivePayout] = useState(false);
    const [url, setUrl] = useState(``);
    return (
        <>
        {!isActivePayout ?
        <div className="bon-section">
        {MoneyExchangeOffer.map((value,i) => (
              <ExchangeOption setUrl={setUrl} setPayout={setIsActivePayout} setPoints={setPoints} points={points} key={i}
              price={value.price}
              amount={value.amount}
              />
          )) }
      </div>:
        <MoneyExchangeFirstStep url={url}></MoneyExchangeFirstStep>
        }


        </>

    )

}


export default MoneyExchange